var height_5 = $('#mini-1-section-5 .counter span').height();
var inView5 = false;

var child5_1 = height_5*2;
var child5_2 = height_5;
var child5_3 = 0;


$(document).ready(function() {

    /* 5 ----------------------------------------------------------- */

    if ($('#mini-1-section-5').length) {
        $('#mini-1-section-5 .counter span').each(function() {
            let orig = parseFloat($(this).text());
            $(this).html('');
            $(this).append(`<div class="orig">${orig}</div>`);
    
            for (let i = 0; i < 2; i++) {
                let random;
                if (orig % 1 !== 0) {
                    let val1 = orig.toString().split(".")[0];
                    let val2 = orig.toString().split(".")[1];
    
                    random = randomNumber(val1) + '.' + randomNumber(val2);
                } 
                else {
                    random = randomNumber(orig);
                }
    
                $(this).append(`<div class="random">${random}</div>`);
            }
        });
    
        $('#mini-1-section-5 .counter div:nth-child(1)').css('top', `${child5_1}px`);
        $('#mini-1-section-5 .counter div:nth-child(2)').css('top', `${child5_2}px`);
        $('#mini-1-section-5 .counter div:nth-child(3)').css('top', `${child5_3}px`);
    }

    /* 10 ------------------------------------------------------------------------------- */

    if ($('#mini-1-section-10').length) {
        let owl_10 = $("#mini-1-section-10 .owl-carousel").owlCarousel({
            items: 1,
            nav: true,
            dots: false,
            loop: true,
            margin: 0,
            smartSpeed: 800,
            navText: ['<i class="fa-solid fa-chevron-left"></i>', '<i class="fa-solid fa-chevron-right"></i>'],
            responsive: {
                0: {
                    margin: 10
                },
                1280: {
                    margin: 0
                }
            }
        }).on('changed.owl.carousel', function(event) {
            
            let currentIndex = event.item.index;
            let owlIndex = $(this).find('.owl-item').eq(currentIndex).find('.item').data('owl')
            
            $('#mini-1-section-10 .owl-toggle span').eq(owlIndex).addClass('active').siblings().removeClass('active');
            
        });
    
        $('#mini-1-section-10 .owl-toggle span').on('click', function() {
            let idx = $(this).index();
    
            owl_10.trigger('to.owl.carousel', idx)
        })
    }

    /* 7 ------------------------------------------------------------------------------------------ */

    if ($('#mini-1-section-7').length) {
        $('#lottie-7_m').on('load', function() {
            LottieInteractivity.create({
                player: '#lottie-7_m',
                mode: 'scroll',
                actions: [
                    {
                        visibility: [0, 1],
                        type: 'seek',
                        frames: [0, 61],
                    },
                ],
            });
        });
    }

    /* 13 ---------------------------------------------------------------------------------------- */

    if ($('#mini-1-section-13').length) {
        let owl_13 = $("#mini-1-section-13 .owl-carousel").owlCarousel({
            items: 1,
            nav: false,
            dots: true,
            loop: false,
            margin: 20,
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 2
                }
            }
        });
    }

});

function randomNumber(number) {
    let length = number.toString().length;
    let min = Math.pow(10, length - 1);
    let max = Math.pow(10, length) - 1;

    return Math.floor(Math.random() * (max - min + 1)) + min;
}

var windowHeight = $(window).outerHeight();
$(window).scroll(function () {

    if ($('#mini-1-section-2').length) {
        $animation_2 = $('#mini-1-section-2 .animation_2');
        if ($(window).scrollTop() > $animation_2.offset().top) {
            let idx = parseInt((($(window).scrollTop() - $animation_2.offset().top) / (
                    $animation_2.outerHeight() - windowHeight)) * $animation_2.find('.imgsSection img')
                .length);
            if (idx >= 0) {

                $animation_2.find('.imgsSection img').eq(idx).show().siblings().hide();

                let visibleFrame = $animation_2.find('.imgsSection img[style!="display: none;"]').first();
                let currentFrame = $animation_2.find('.imgsSection img').index(visibleFrame);
                let lastFrame = $animation_2.find('.imgsSection img').last().index();

                if (currentFrame <= 60) {
                    $animation_2.find('.text-top').css('opacity', 1);
                    $animation_2.find('.specs').css('opacity', 1);
                }
                else {
                    $animation_2.find('.text-top').css('opacity', 0);
                    $animation_2.find('.specs').css('opacity', 0);
                }
                
                if (currentFrame <= 20 )
                    $animation_2.find('.text-top .text:eq(0)').addClass('active');
                else {
                    $animation_2.find('.text-top .text:eq(0)').find('.faded.in').addClass('out');
                    $animation_2.find('.text-top .text:eq(0)').removeClass('active');
                }
            
                if (currentFrame >= 21 && currentFrame <= 40 )
                    $animation_2.find('.text-top .text:eq(1)').addClass('active');
                else {
                    $animation_2.find('.text-top .text:eq(1)').find('.faded.in').addClass('out');
                    $animation_2.find('.text-top .text:eq(1)').removeClass('active');
                }
            
                if (currentFrame >= 41 && currentFrame <= 70 )
                    $animation_2.find('.text-top .text:eq(2)').addClass('active');
                else {
                    $animation_2.find('.text-top .text:eq(2)').find('.faded.in').addClass('out');
                    $animation_2.find('.text-top .text:eq(2)').removeClass('active');
                }

                if (currentFrame >= 110 && currentFrame <= 150 )
                    $animation_2.find('.text-middle').addClass('active');
                else {
                    $animation_2.find('.text-middle').find('.faded.in').addClass('out');
                    $animation_2.find('.text-middle').removeClass('active');
                }
                    
                if (currentFrame >= 170 && currentFrame <= lastFrame )
                    $animation_2.find('.text-last').addClass('active');
                else {
                    $animation_2.find('.text-last').find('.faded.in').addClass('out');
                    $animation_2.find('.text-last').removeClass('active');
                }

                /* ----------- */
                if ($animation_2.find('.text-container .active').find('.faded').length > 0) {
                    $animation_2.find('.text-container .active').find('.faded').addClass('in');
                }
                if ($animation_2.find('.text-container').find('.faded.in.out').length > 0) {
                    setTimeout(() => {
                        $animation_2.find('.text-container').find('.faded.in.out').removeClass('in').removeClass('out');
                    }, 500);
                }
                /* ----------- */

            }
        }
        
        $animation_2m = $('#mini-1-section-2 .animation_2m');
        if ($(window).scrollTop() > $animation_2m.offset().top) {
            let idx = parseInt((($(window).scrollTop() - $animation_2m.offset().top) / (
                    $animation_2m.outerHeight() - windowHeight)) * $animation_2m.find('.imgsSection img')
                .length);
            if (idx >= 0) {

                $animation_2m.find('.imgsSection img').eq(idx).show().siblings().hide();

                let visibleFrame = $animation_2m.find('.imgsSection img[style!="display: none;"]').first();
                let currentFrame = $animation_2m.find('.imgsSection img').index(visibleFrame);
                let lastFrame = $animation_2m.find('.imgsSection img').last().index();

                if (currentFrame <= 60) {
                    $animation_2m.find('.text-top').css('opacity', 1);
                    $animation_2m.find('.specs').css('opacity', 1);
                }
                else {
                    $animation_2m.find('.text-top').css('opacity', 0);
                    $animation_2m.find('.specs').css('opacity', 0);
                }
                
                if (currentFrame <= 20 )
                    $animation_2m.find('.text-top .text:eq(0)').addClass('active');
                else {
                    $animation_2m.find('.text-top .text:eq(0)').find('.faded.in').addClass('out');
                    $animation_2m.find('.text-top .text:eq(0)').removeClass('active');
                }
            
                if (currentFrame >= 21 && currentFrame <= 40 )
                    $animation_2m.find('.text-top .text:eq(1)').addClass('active');
                else {
                    $animation_2m.find('.text-top .text:eq(1)').find('.faded.in').addClass('out');
                    $animation_2m.find('.text-top .text:eq(1)').removeClass('active');
                }
            
                if (currentFrame >= 41 && currentFrame <= 70 )
                    $animation_2m.find('.text-top .text:eq(2)').addClass('active');
                else {
                    $animation_2m.find('.text-top .text:eq(2)').find('.faded.in').addClass('out');
                    $animation_2m.find('.text-top .text:eq(2)').removeClass('active');
                }

                if (currentFrame >= 95 && currentFrame <= 110 )
                    $animation_2m.find('.text-middle').addClass('active');
                else {
                    $animation_2m.find('.text-middle').find('.faded.in').addClass('out');
                    $animation_2m.find('.text-middle').removeClass('active');
                }
                    
                if (currentFrame >= 120 && currentFrame <= lastFrame )
                    $animation_2m.find('.text-last').addClass('active');
                else {
                    $animation_2m.find('.text-last').find('.faded.in').addClass('out');
                    $animation_2m.find('.text-last').removeClass('active');
                }

                /* ----------- */
                if ($animation_2m.find('.text-container .active').find('.faded').length > 0) {
                    $animation_2m.find('.text-container .active').find('.faded').addClass('in');
                }
                if ($animation_2m.find('.text-container').find('.faded.in.out').length > 0) {
                    setTimeout(() => {
                        $animation_2m.find('.text-container').find('.faded.in.out').removeClass('in').removeClass('out');
                    }, 500);
                }
                /* ----------- */

            }
        }
    }

    /* 3 ------------------------------------------------------------------------------- */

    if ($('#mini-1-section-3').length) {
        $section3 = $('#mini-1-section-3');
        if (visiblePercent($section3) > 40) {
            if (!$section3.find('.image-container').hasClass('aos-animate'))
                $section3.find('.image-container').addClass('aos-animate');

            setTimeout(() => {
                $section3.find('.cpu').css('top', '0');
                $section3.find('.texts').addClass('aos-animate');
            }, 1000);
        }
        else {
            if ($section3.find('.image-container').hasClass('aos-animate'))
                $section3.find('.image-container').removeClass('aos-animate');

            setTimeout(() => {
                $section3.find('.cpu').css('top', '80px');
                $section3.find('.texts').removeClass('aos-animate');
            }, 1000);
        }
    }

    /* 4 ---------------------------------------------------------------------------- */

    if ($('#mini-1-section-4').length) {
        $section4_1 = $('#mini-1-section-4 .clip-anchor');
        $section4_2 = $('#mini-1-section-4 .viewport-anchor');

        let path4 = 20;
        if (wSize >= 1280) {
            if ($('#mini-1-section-4 .viewport-anchor').length) 
                path4 = (visiblePercent($section4_1)/10) + (visiblePercent($section4_2)/10);
            else
                path4 = (visiblePercent($section4_1)/10);
        }
            
        $('#mini-1-section-4 .clip').css('clip-path', `polygon(${20-path4}% 0, ${80+path4}% 0, ${80+path4}% 100%, ${20-path4}% 100%)`);

        $video4 = $('#mini-1-section-4 .video-bg .container');
        if ($video4.length) {
            if (isInFull($video4) == 'full') {
                $('#mini-1-section-4 .video-bg .absVideo').css({
                    'position': 'fixed',
                    'top': '0',
                    'bottom': 'unset'
                });
            }
            else if (isInFull($video4) == 'partial-bottom') {
                $('#mini-1-section-4 .video-bg .absVideo').css({
                    'position': 'absolute',
                    'top': '0',
                    'bottom': 'unset'
                });
            }
            else {
                $('#mini-1-section-4 .video-bg .absVideo').css({
                    'position': 'absolute',
                    'top': 'unset',
                    'bottom': '0'
                });
            }
        }
    }

    /* 5 ---------------------------------------------------------------------------- */

    if ($('#mini-1-section-5').length) {
        $('#mini-1-section-5 .aos-init').each(function() {
            if (isElementInView($(this))) {
                $(this).addClass('aos-animate');
            }
            else {
                $(this).removeClass('aos-animate');
            }
        });
    
        $section5 = $('#mini-1-section-5 .custom-gutter-2');
        if (isElementInView($section5)) {
            if (!inView5) { 
                setTimeout(() => {
                    $('#mini-1-section-5 .counter div:nth-child(1)').css('top', `${child5_1-height_5}px`);
                    $('#mini-1-section-5 .counter div:nth-child(2)').css('top', `${child5_2-height_5}px`);
                    $('#mini-1-section-5 .counter div:nth-child(3)').css('top', `${child5_3-height_5}px`);
                }, 200);
                setTimeout(() => {
                    $('#mini-1-section-5 .counter div:nth-child(1)').css('top', `${child5_1-(height_5*2)}px`);
                    $('#mini-1-section-5 .counter div:nth-child(2)').css('top', `${child5_2-(height_5*2)}px`);
                    $('#mini-1-section-5 .counter div:nth-child(3)').css('top', `${child5_3-(height_5*2)}px`);
                }, 400);
    
                inView5 = true;
            }
        }
        else {
            if (inView5) {
                $('#mini-1-section-5 .counter div:nth-child(1)').css('top', `${child5_1}px`);
                $('#mini-1-section-5 .counter div:nth-child(2)').css('top', `${child5_2}px`);
                $('#mini-1-section-5 .counter div:nth-child(3)').css('top', `${child5_3}px`);
    
                inView5 = false;
            }
        }
    }

    /* 6 ------------------------------------------------------------------------ */

    if ($('#mini-1-section-6').length) {
        $section6 = $('#mini-1-section-6');

    if (visiblePercent($section6) > 0 && visiblePercent($section6) < 50) {
        $('#mini-1-section-6 .sticky .container:nth-child(1)').css('opacity', 1);
        $('#mini-1-section-6 .sticky .container:nth-child(2) img').css('transform', 'scale(1.5)');
    }
    else {
        $('#mini-1-section-6 .sticky .container:nth-child(1)').css('opacity', 0);
    }

    if (visiblePercent($section6) > 50 && visiblePercent($section6) < 75) {
        $('#mini-1-section-6 .sticky .container:nth-child(2)').css('opacity', 1);
        $('#mini-1-section-6 .sticky .container:nth-child(2) img').css('transform', 'scale(1)');
    }
    else {
        $('#mini-1-section-6 .sticky .container:nth-child(2)').css('opacity', 0);
    }

    if (visiblePercent($section6) > 75) {
        $('#mini-1-section-6 .sticky .container:nth-child(3)').css('opacity', 1);
    }
    else {
        $('#mini-1-section-6 .sticky .container:nth-child(3)').css('opacity', 0);
    }
    
    }

    /* 7 ------------------------------------------------------------------------ */

    if ($('#mini-1-section-7').length) {
        $animation_7 = $('#mini-1-section-7 .animation_7');
        if ($(window).scrollTop() > $animation_7.offset().top) {
            let idx = parseInt((($(window).scrollTop() - $animation_7.offset().top) / (
                    $animation_7.outerHeight() - windowHeight)) * $animation_7.find('.imgsSection img')
                .length);
            if (idx >= 0) {

                $animation_7.find('.imgsSection img').eq(idx).show().siblings().hide();

                let visibleFrame = $animation_7.find('.imgsSection img[style!="display: none;"]').first();
                let currentFrame = $animation_7.find('.imgsSection img').index(visibleFrame);
                let lastFrame = $animation_7.find('.imgsSection img').last().index();

            }
        }
    }

    /* 9 ------------------------------------------------------------------------ */

    if ($('#mini-1-section-9').length) {
        $section9 = $('#mini-1-section-9 .front');
        if (isElementInView($section9)) {
            $('#mini-1-section-9 .rear').css('transform', 'translateX(-50%) scale(1)');
        }
        else {
            $('#mini-1-section-9 .rear').css('transform', 'translateX(-50%) scale(.8)');
        }
    }
});

$('#mini-1-section-8 .clippy .clip-item').on('mouseover', function() {
    $(this).addClass('active').siblings().removeClass('active');
}).on('mouseleave', function() {
    $('#mini-1-section-8 .clippy .clip-item').removeClass('active');
    $('#mini-1-section-8 .clippy .clip-item:nth-child(1)').addClass('active');
});

$('#mini-1-section-11 .toggle-player').on('click', function() {
    let video = $('#mini-1-section-11 #thisVideo')[0];

    if (video.paused) {
        video.play();
        $('#mini-1-section-11 .toggle-player .pause').addClass('active');
        $('#mini-1-section-11 .toggle-player .play').removeClass('active');
    } 
    else {
        video.pause();
        $('#mini-1-section-11 .toggle-player .pause').removeClass('active');
        $('#mini-1-section-11 .toggle-player .play').addClass('active');
    }
});